import _get from 'lodash/get';
import _head from 'lodash/head';
import _map from 'lodash/map';
import _parseInt from 'lodash/parseInt';
import _set from 'lodash/set';
import _split from 'lodash/split';
import _transform from 'lodash/transform';
import APPCONFIG from '../../constants/Config';
import { WS_TOPIC_INSTALLATIONS, WS_TOPIC_ENTITIES } from '../../constants/App';
import * as wsEvents from '../../constants/WsEvents';
import {
  REINIT_STATE,
  WS_RECEIVED_OPERATION,
  RESET_INSTALLATION_CACHE,
  GET_INSTALLATIONS_LIST,
  GET_INSTALLATIONS_LIST_SUCCESS,
  GET_INSTALLATIONS_LIST_ERROR,
  ADD_INSTALLATION,
  ADD_INSTALLATION_SUCCESS,
  ADD_INSTALLATION_ERROR,
  GET_INSTALLATION,
  GET_INSTALLATION_SUCCESS,
  GET_INSTALLATION_ERROR,
  UPDATE_INSTALLATION,
  UPDATE_INSTALLATION_SUCCESS,
  UPDATE_INSTALLATION_ERROR,
  DELETE_INSTALLATION,
  DELETE_INSTALLATION_SUCCESS,
  DELETE_INSTALLATION_ERROR,
  GET_EQUIPMENTS_LIST_SUCCESS,
  GET_INSTALLATION_DOORS_SUCCESS,
  GET_INSTALLATION_SOURCES_SUCCESS,
  GET_INSTALLATION_DEVICES_SUCCESS,
  GET_INSTALLATION_SCENARIOS_SUCCESS,
  GET_INSTALLATION_PLANNINGS_SUCCESS,
  SET_INSTALLATION_PERMISSIONS,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/installation';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.installation;
const installation = (state = initialSettings, action) => {
  let key;
  let wsPayload;
  let wsTopic;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullInstallation') {
        return {
          ...state,
          cache: { ...initialSettings.cache },
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
          permissions: [],
        };
      }
      if (action.target === 'currentInstallation') {
        return {
          ...state,
          cache: { ...initialSettings.cache },
          current: { ...initialSettings.current },
          permissions: [],
        };
      }
      switch (action.target) {
        case 'addInstallation':
          key = 'add';
          break;
        case 'updateInstallation':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // WEB SOCKET
    case WS_RECEIVED_OPERATION:
      wsPayload = action.payload;
      wsTopic = _head(_split(action.topic, ':'));
      if (wsPayload && wsTopic && action.operation === wsEvents.EVENT_HEAD) {
        if (wsTopic === WS_TOPIC_INSTALLATIONS) {
          // Check if the concerned installation is the current one
          if (_get(state, 'current.data.id') === wsPayload.id) {
            return {
              ...state,
              current: {
                ...state.current,
                data: {
                  ...state.current.data,
                  sync_status: wsPayload.sync_status,
                },
              },
            };
          }
          return state;
        }
        if (wsTopic === WS_TOPIC_ENTITIES) {
          // Update the list of entites by updating sync status of the concerned entity
          return {
            ...state,
            current: {
              ...state.current,
              data: {
                ...state.current.data,
                entities: _map(state.current.data.entities, (entity) => (entity.id === wsPayload.id
                  ? {
                    ...entity,
                    sync_status: wsPayload.sync_status,
                  } : entity
                )),
              },
            },
          };
        }
        return state;
      }
      return state;
    // CACHE MANAGEMENT
    case RESET_INSTALLATION_CACHE:
      return {
        ...state,
        cache: _transform(state.cache, (result, value, key) => { // eslint-disable-line no-shadow
          _set(result, key, false);
          return result;
        }, {}),
      };
    case GET_EQUIPMENTS_LIST_SUCCESS:
    case GET_INSTALLATION_DOORS_SUCCESS:
    case GET_INSTALLATION_SOURCES_SUCCESS:
    case GET_INSTALLATION_DEVICES_SUCCESS:
    case GET_INSTALLATION_SCENARIOS_SUCCESS:
    case GET_INSTALLATION_PLANNINGS_SUCCESS:
      key = null;
      switch (action.type) {
        case GET_EQUIPMENTS_LIST_SUCCESS:
          key = 'equipments';
          break;
        case GET_INSTALLATION_DOORS_SUCCESS:
          key = 'doors';
          break;
        case GET_INSTALLATION_SOURCES_SUCCESS:
          key = 'sources';
          break;
        case GET_INSTALLATION_DEVICES_SUCCESS:
          key = 'devices';
          break;
        case GET_INSTALLATION_SCENARIOS_SUCCESS:
          key = 'scenarios';
          break;
        case GET_INSTALLATION_PLANNINGS_SUCCESS:
          key = 'plannings';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          cache: {
            ...state.cache,
            [key]: true,
          },
        };
      }
      return state;
    // LIST
    case GET_INSTALLATIONS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_INSTALLATIONS_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATIONS_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    // ADD
    case ADD_INSTALLATION:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case ADD_INSTALLATION_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_INSTALLATION_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          asyncOperation: action.data.data,
        },
      };
    // GET
    case GET_INSTALLATION:
      return {
        ...state,
        cache: {
          ...initialSettings.cache,
        },
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INSTALLATION_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // UPDATE
    case UPDATE_INSTALLATION:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
          idInstallation: action.id,
        },
      };
    case UPDATE_INSTALLATION_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_INSTALLATION_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          asyncOperation: action.data.data,
        },
      };
    // DELETE
    case DELETE_INSTALLATION:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_INSTALLATION_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_INSTALLATION_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    case SET_INSTALLATION_PERMISSIONS:
      return {
        ...state,
        permissions: action.permissions,
      };
    default:
      return state;
  }
};

export default installation;



// WEBPACK FOOTER //
// ./reducers/installation/installation.js